import { Footer } from "@/components/LandingPage/Footer";
import { Header } from "@/components/LandingPage/Header";

export default function FourZeroFour() {
  return (
    <>
      <Header dark={false} />
      <main className="flex justify-center pb-32">
        <div className="max-w-4xl">
          <h1 className="text-3xl bold">404 page not found.</h1>
        </div>
      </main>
      <Footer />
    </>
  );
}
